import {IColumn} from 'models/library/common';

export const columns: IColumn[] = [
  {id: 'name', label: ''},
  {id: 'viewBtn', label: '', align: 'right', className: 'btn-col'},
];
